import { render, staticRenderFns } from "./index.vue?vue&type=template&id=af309006&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=af309006&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af309006",
  null
  
)

export default component.exports